export enum PaymentGateway {
  GREEN_PAY = 'GREEN_PAY',
  INESPAY = 'INESPAY',
  INGENICO = 'INGENICO',
  MONEI = 'MONEI',
  MONEI_BIZUM = 'MONEI_BIZUM',
  MONETICO = 'MONETICO',
  MYMOID = 'MYMOID',
  PAYCOMET = 'PAYCOMET',
  PAYCOMET_BIZUM = 'PAYCOMET_BIZUM',
  PAYCOMET_MBWAY = 'PAYCOMET_MBWAY',
  PAYCOMET_MULTIBANCO_SIBS = 'PAYCOMET_MULTIBANCO_SIBS',
  REDSYS = 'REDSYS',
  REDSYS_BIZUM = 'REDSYS_BIZUM',
  STRIPE = 'STRIPE',
  ADYEN = 'ADYEN',
  PAYMEFY = 'PAYMEFY',
}
